import React from 'react'
import PropTypes from 'prop-types'

const Call = ({ color }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.34564 9.92949C8.19858 9.92949 7.06854 9.66209 5.95554 9.12729C4.84207 8.59249 3.84784 7.88759 2.97284 7.01259C2.09784 6.13759 1.39294 5.14593 0.858141 4.03759C0.323807 2.92926 0.0566406 1.79666 0.0566406 0.639792C0.0566406 0.474592 0.117307 0.333659 0.238641 0.216992C0.359974 0.100326 0.503241 0.0419922 0.668441 0.0419922H2.62284C2.77871 0.0419922 2.91007 0.0881922 3.01694 0.180592C3.12381 0.272525 3.19171 0.391525 3.22064 0.537592L3.58534 2.30229C3.60494 2.43856 3.59771 2.56246 3.56364 2.67399C3.52957 2.78599 3.46891 2.88073 3.38164 2.95819L2.03974 4.28539C2.46767 5.02413 2.99501 5.70966 3.62174 6.34199C4.24894 6.97386 4.96107 7.51823 5.75814 7.97509L7.05664 6.63319C7.16351 6.52633 7.27037 6.45843 7.37724 6.42949C7.48411 6.40009 7.60567 6.39519 7.74194 6.41479L9.44784 6.77949C9.59391 6.79863 9.71314 6.86163 9.80554 6.96849C9.89747 7.07583 9.94344 7.20719 9.94344 7.36259V9.31699C9.94344 9.48219 9.88511 9.62546 9.76844 9.74679C9.65178 9.86859 9.51084 9.92949 9.34564 9.92949ZM1.60224 3.39569L2.59344 2.44789C2.61304 2.42829 2.62541 2.40636 2.63054 2.38209C2.63521 2.35783 2.63264 2.33123 2.62284 2.30229L2.37504 1.06259C2.36524 1.03319 2.35077 1.01126 2.33164 0.996792C2.31204 0.982326 2.28754 0.975092 2.25814 0.975092H1.09194C1.06254 0.975092 1.04061 0.982326 1.02614 0.996792C1.01167 1.01126 1.00444 1.02829 1.00444 1.04789C1.03337 1.43709 1.09637 1.82606 1.19344 2.21479C1.29097 2.60353 1.42724 2.99716 1.60224 3.39569ZM8.93754 8.96699C8.95714 8.96699 8.97417 8.95953 8.98864 8.94459C9.00311 8.93013 9.01034 8.91309 9.01034 8.89349V7.72729C9.01034 7.69789 9.00311 7.67363 8.98864 7.65449C8.97417 7.63489 8.95224 7.62019 8.92284 7.61039L7.72724 7.36259C7.70764 7.35279 7.68804 7.35279 7.66844 7.36259L7.61034 7.39199L6.63314 8.41259C7.02234 8.57779 7.41364 8.70426 7.80704 8.79199C8.20091 8.87926 8.57774 8.93759 8.93754 8.96699Z"
        fill={color}
      />
    </svg>
  )
}

Call.propTypes = {
  color: PropTypes.string,
}

Call.defaultProps = {
  color: 'red',
}

export default Call
